import { breadcrumbStylesExtension } from "@thkStore/WidgetExtensions/BreadCrumbStylesExtension";
import { cartPageContainerStylesExtension } from "@thkStore/WidgetExtensions/CartPageContainerStylesExtension";
import { customerAddressFormFieldStylesExtension } from "@thkStore/WidgetExtensions/CustomerAddressFormFieldsExtension";

export const importWidgetExtensions = {
    breadcrumbStylesExtension,
    cartPageContainerStylesExtension,
    customerAddressFormFieldStylesExtension,

}